import type {
  ChatRole,
  ParsedBlock,
  ParsedBlockType,
  ParsedMessage,
  Turn,
} from '@/features/votes/chat-message';

// Mirror backend mid_turn_state.py
const MID_TURN_STUB_MARKER = '<mid-turn-compacted>';
const MID_TURN_SUMMARY_MARKER = '<mid-turn-compaction-summary>';

const KNOWN_PREFIXES: Record<string, ParsedBlockType> = {
  text: 'text',
  thought: 'thought',
  tool_use: 'tool_use',
  tool_result: 'tool_result',
  modalities: 'modalities',
  thought_signature: 'thought_signature',
};

function blockFromPart(part: string): ParsedBlock {
  const colon = part.indexOf(':');
  if (colon === -1) return { type: 'text', value: part };
  const key = part.slice(0, colon);
  const value = part.slice(colon + 1);
  if (key in KNOWN_PREFIXES) return { type: KNOWN_PREFIXES[key], value };
  if (key.startsWith('image/')) return { type: 'image', value, key };
  return { type: 'unknown', value, key };
}

export function parseMessage(parts: string[], index: number): ParsedMessage {
  const role = (parts[0] as ChatRole) ?? 'assistant';
  const message: ParsedMessage = { role, blocks: [], index };
  for (const part of parts.slice(1)) {
    if (part.startsWith('id:')) message.id = part.slice('id:'.length);
    else if (part.startsWith('created_at:'))
      message.createdAt = part.slice('created_at:'.length);
    else if (part.startsWith('updated_at:'))
      message.updatedAt = part.slice('updated_at:'.length);
    else if (part.startsWith('agent:'))
      message.agent = part.slice('agent:'.length);
    else message.blocks.push(blockFromPart(part));
  }
  return message;
}

export function parseChatHistory(chatHistory: string[][]): ParsedMessage[] {
  return chatHistory.map((parts, i) => parseMessage(parts, i));
}

export function groupIntoTurns(messages: ParsedMessage[]): Turn[] {
  const turns: Turn[] = [];
  for (const message of messages) {
    if (message.role === 'user' || turns.length === 0) {
      turns.push({
        turnNumber: turns.length + 1,
        messages: [message],
        startIndex: message.index,
        endIndex: message.index,
      });
    } else {
      const current = turns[turns.length - 1];
      current.messages.push(message);
      current.endIndex = message.index;
    }
  }
  return turns;
}

export type MidTurnCompaction = 'stub' | 'summary' | null;

export function detectMidTurnCompaction(
  toolResultText: string
): MidTurnCompaction {
  if (toolResultText.includes(MID_TURN_SUMMARY_MARKER)) return 'summary';
  if (toolResultText.includes(MID_TURN_STUB_MARKER)) return 'stub';
  return null;
}
